class TSMainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-dynamic-variants]").textContent);
    this.cart = document.querySelector("cart-drawer");
    
    this.querySelector('[id^="ProductForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.querySelector('.ts-subscription')?.addEventListener("change", this.onSubscriptionChange.bind(this));

    this.initGallery();
    this.initClickListeners();
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();    

    if (this.isLoading) return;

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value),
          selling_plan: parseInt(this.querySelector("[name='selling_plan']").value)
        }
      ]
    };

    if (this.cart) {
      cartData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
      cartData['sections_url'] = window.location.pathname
    }

    this.addToCart(cartData);
  }

  onSubscriptionChange(event) {
    const form = event.target.closest("form");
    const sellingPlanInput = form.querySelector('[name="selling_plan"]');

    sellingPlanInput.value = event.target.value;    
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContents(response);
          this.cart.classList.remove("is-empty");
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = ['[id^="ProductPrice-"]', '[id^="ProductOptions-"]', '[id^="ProductSubmit-"]'];

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="ProductSubmit-"]')) {
      const currentButton = this.querySelector('[id^="ProductSubmit-"]');
      const newButton = section.querySelector('[id^="ProductSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initGallery() {
    this.gallery = this.querySelector('[id^="TSProductGallery-"]');
    this.navGallery = this.querySelector('[id^="TSProductGalleryNav-"]');

    this.gallerySlide = 1;

    this.gallery.addEventListener('scroll', () => {
      const items = this.gallery.querySelectorAll('li');
      const scrollLeft = this.gallery.scrollLeft;
      const blockWidth = items[0]?.offsetWidth ?? 0;
      const gap = 12;
        
      this.gallerySlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

      items.forEach((item, index) => {
        if (index == (this.gallerySlide - 1)) {
          item.querySelector("video")?.play();
        } else {
          item.querySelector("video")?.pause();
        }
      })
      
      this.navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == this.gallerySlide);
      })
    });
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "prev-slide":
            if (this.gallerySlide > 1) {
              this.scrollToSlide(this.gallery, this.gallerySlide - 1);
            }
            break;
          case "change-slide":
            this.scrollToSlide(this.gallery, parseInt(e.target.dataset.slide));
            break;
          case "next-slide":
            if (this.gallerySlide < this.gallery.querySelectorAll("li").length) {
              this.scrollToSlide(this.gallery, this.gallerySlide + 1);
            }
            break;
          case "toggle-disclosure":
            const disclosureContent = e.target.nextElementSibling;
        
            e.target.classList.toggle("open");
            disclosureContent.style.maxHeight = e.target.classList.contains("open") ? disclosureContent.scrollHeight + "px" : null;
            break;
          case "add-upsell":
            if (!this.isLoading) {
              const upsellCartData = {
                items: [
                  {
                    id: parseInt(e.target.dataset.variant),
                    quantity: 1
                  }
                ]
              };

              if (this.cart) {
                upsellCartData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
                upsellCartData['sections_url'] = window.location.pathname
              }
              this.addToCart(upsellCartData);
            }
            break;
        }
      }
    })
  }

  scrollToSlide(slider, index) {
    if (!slider) return;

    slider.scrollTo({
      left: slider.querySelector(`li:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-main-product", TSMainProduct);